// removed by extract-text-webpack-plugin
module.exports = {"button":"_3o1yP","input":"_3yQso"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-upload-button.scss
// module id = 713
// module chunks = 3 4 5 6 7